import { useNavigate } from "react-router-dom";
import "./ExploreBlock.css";
import rightArrow from "../../../../assets/img/homeV2/Right-Arrow.png";

/**
 * ExploreBlock — A reusable left-right content section.
 *
 * Props:
 *  @param {string}  title       — Section heading
 *  @param {string}  description — Paragraph text
 *  @param {string}  image       — Image URL
 *  @param {string}  imageAlt    — Alt text for the image
 *  @param {boolean} [reversed]  — If true, image goes left, text right
 *  @param {string}  [ctaText]   — Button label (default: "Get Started")
 *  @param {string}  [ctaLink]   — Navigate target (default: "/signup")
 *  @param {boolean} [comingSoon] — If true, show a "Coming Soon" badge on the image
 *  @param {string}  [id]        — Section id for anchoring
 */
export const ExploreBlock = ({
  title,
  description,
  image,
  imageAlt,
  reversed = false,
  ctaText = "Get Started",
  ctaLink = "/student/festival",
  comingSoon = false,
  id,
}) => {
  const navigate = useNavigate();

  return (
    <section className="exploreBlock" id={id}>
      <div
        className={`exploreBlock__container ${
          reversed ? "exploreBlock__container--reversed" : ""
        }`}
      >
        {/* ---------- Text Column ---------- */}
        <div className="exploreBlock__text">
          <h2 className="exploreBlock__title">
            {" "}
            <img
              className="howitwrkicn"
              src="https://d2lvj32mp5x83n.cloudfront.net/static/homev3/image 94.png"
              alt=""
            />
            {title}
            <img
              className="howitwrkrgticn"
              src="https://d2lvj32mp5x83n.cloudfront.net/static/homev3/image 95.png"
              alt=""
            />
          </h2>
          <p className="exploreBlock__description">{description}</p>
          {!reversed && (
            <button
              className="exploreBlock__cta"
              onClick={() => navigate(ctaLink)}
            >
              {ctaText}
              <img src={rightArrow} alt="" />
            </button>
          )}
        </div>

        {/* ---------- Image Column ---------- */}
        <div className="exploreBlock__imageWrap">
          <img
            src={image}
            alt={imageAlt || title}
            className="exploreBlock__image"
          />
          {comingSoon && (
            <span className="exploreBlock__comingSoon">COMING SOON!</span>
          )}
        </div>
      </div>
    </section>
  );
};
